// app/javascript/controllers/text_toggle_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "icon", "button"]

  static values = {
    buttonText: String
  }

  toggle() {
    this.textTarget.classList.toggle('max-h-96'); // Высота полного текста
    this.textTarget.classList.toggle('overflow-hidden'); // Добавьте это, чтобы показать многоточие, если текст скрыт
    this.textTarget.classList.toggle('overflow-hidden'); // Скрытие текста
    this.iconTarget.classList.toggle("rotate-180");

   // Теперь меняем текст кнопки напрямую
   if (this.buttonTarget.textContent.includes("Читать весь текст")) {
    this.buttonTarget.textContent = "Скрыть текст";
  } else {
    this.buttonTarget.textContent = "Читать весь текст";
  }
  }
}
